// extracted by mini-css-extract-plugin
module.exports = {"menu-group":"menu_menu-group__17NUJ","menu-group-label":"menu_menu-group-label__3VW_X"};